/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/GiftCards/GiftCards.Forms',[], function () {
    'use strict';

    var forms = {
        CertificateDetails: {
            Fields: [
                {
                    "Name": 'From Name',
                    "Field": '#certificateFromName',
                    "Param": 'certificateFromName',
                    "Type": 'Text'
                },
                {
                    "Name": 'To Name',
                    "Field": '#certificateToName',
                    "Param": 'certificateToName',
                    "Type": 'Text'
                },
                {
                    "Name": 'Recipient E-mail',
                    "Field": '#certificateToEmail',
                    "Param": 'certificateToEmail',
                    "Type": 'Text',
                    "Validators": [{ "Type": 'Email' }]
                },
                {
                    "Name": 'Message',
                    "Field": '#certificateMessage',
                    "Param": 'certificateMessage',
                    "Type": 'Text'
                }
            ],
            Validate: true
        },
        CertificatePayment: {
            Fields: [
                {
                    "Name": 'Card Number',
                    "Field": '[data-certificateNumber]',
                    "Param": 'cardNumber',
                    "Type": 'Text'
                },
                {
                    "Name": 'PIN',
                    "Field": '[data-certificatePin]',
                    "Param": 'pin',
                    "Type": 'Text'
                },
                {
                    "Name": 'Verification Code',
                    "Field": '[data-certificateVerificationCode]',
                    "Param": 'verificationCode',
                    "Type": 'Text'
                }
            ],
            Validate: true
        }
    };

    return forms;
});
